import { useContext, useEffect } from "react";
import ToasterV2 from "../Toaster/ToasterV2";
import { showToaster } from "../../../context/action/toaster/toaster";
import BodyTable from "./BodyTable/BodyTable";
import FooterTable from "./FooterTable/FooterTable";
import HeaderTable from "./HeaderTable/HeaderTable";
import { AdminContext } from "../../../../_+_Portal/_-_Admin/context/Provider";
import { GlobalContext } from "../../../context/Provider";

const Table = ({configTable}) => {
    const {
        abmState
    } = useContext(AdminContext);

    const {
        toasterState,
        toasterDispatch
    } = useContext(GlobalContext);
    
    // Levantando los errores 
    useEffect(() => {
        if(abmState.abm.error){
            showToaster(
                {
                  texto: abmState.abm.error,
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
        }
    }, [abmState.abm.error])

    // Levantando éxitos
   
    return (
        <>
            {toasterState.toaster.show && <ToasterV2 />}
            <HeaderTable configTable={configTable} />
            <BodyTable configTable={configTable} />
            <FooterTable configTable={configTable} />
        </>
    )
}

export default Table; 